import React from 'react';

import './textInput.style.css';

const TextInput = ({
  placeHolder,
  header,
  setText,
  inputText,
  disabled
}) => {

  const changeHandler = (event) => {
    const newText = event.target.value
    setText(newText.trim())
  };

  return (
    <div className='text-input-container'>
      {header && (
        <label className='label'>
            {header}
        </label>
      )}
      <input
          className="input"
          type="text"
          value={inputText}
          onChange={changeHandler}
          placeholder={placeHolder}
          disabled={disabled}
      />
    </div>
  );
}

export default TextInput;
